// Shared CSS-in-JS helper. Every component/view module exports its own
// `export const css = \`...\`` string and calls this at module top-level,
// so the rule is injected the moment the module is evaluated — before its
// render function is ever called — and double-injection (e.g. a chunk
// bundled into two separate output files) is a no-op.
export function injectStyle(id, css) {
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  document.head.appendChild(style);
}
